import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  GroupedSearchFilterFacet,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import {
  ViewableColumnSubType,
  ViewableColumnType,
} from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}export/filteredFiles`;

export enum EXPORT_FORMAT {
  CSV = 'Csv',
  EXCEL = 'Excel',
}

export interface SelectedColumnForExport {
  key: string;
  columnType?: ViewableColumnType;
  columnSubType?: ViewableColumnSubType;
  children?: SelectedColumnForExport[];
  isSortable?: boolean;
  label?: string;
}

export interface ExportFilteredFilesCommandArgs {
  query?: string;
  exportFormat: EXPORT_FORMAT;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  sortOptions?: SortOption[];
  selectedColumns?: SelectedColumnForExport[];
  dateTimeFilters?: DateTimeFilter[];
  sellerId?: string;
  tenantId?: string;
}

async function exportFilteredFilesCommand({
  exportFormat,
  query,
  filters,
  groupedFilters,
  sortOptions,
  selectedColumns,
  dateTimeFilters,
  sellerId,
  tenantId,
}: ExportFilteredFilesCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        filters,
        groupedFilters,
        exportFormat,
        sortOptions,
        selectedColumns,
        dateTimeFilters,
        sellerId,
        tenantId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default exportFilteredFilesCommand;
